import React from 'react';
import CandidateManagementPage from './CandidateManagementComponents/CandidateManagementPage';

const CandidateManagementView = (props) => {
  return <CandidateManagementPage {...props} />;
};

export default CandidateManagementView;
